import { baseApi } from './baseApi'

const api = baseApi.injectEndpoints({
  endpoints: (build) => ({
    generateImage: build.mutation<any, { prompt: string }>({
      query: ({ prompt }) => ({
        url: `ai/generate-image`,
        method: 'POST',
        body: { prompt },
      }),
    }),
  }),
})

export const { useGenerateImageMutation } = api
